<script setup lang="ts">

import { type LocationAsRelativeRaw } from 'vue-router'

const props = defineProps<{
  label: string;
  icon: string;
  route: LocationAsRelativeRaw;
  disabled: boolean;
}>()

const emit = defineEmits<{
  (e: 'widget-link-click'): void
}>()

function handleClick() {
  if (props.disabled) return

  emit('widget-link-click')
}
</script>

<template>
  <component
    :is="disabled ? 'div' : 'router-link'"
    v-bind="disabled ? {} : { to: route }"
    class="group w-[5.5rem] border-0 bg-transparent p-0 text-inherit no-underline"
    :class="{ 'cursor-not-allowed opacity-50': disabled }"
    @click.native="handleClick"
  >
    <div
      class="flex h-[5.5rem] w-full items-center justify-center rounded-xl
             bg-background-normal transition-colors duration-300 group-hover:bg-primary-pale"
    >
      <sword-icon
        :name="icon"
        class="!h-auto !w-10 fill-context-1 transition-colors duration-300
               disabled:fill-gray-500 group-hover:fill-primary"
      />
    </div>
    <p
      class="mb-0 mt-2 truncate text-center text-xs font-medium text-context-1 transition-colors duration-300
             disabled:text-gray-500 group-hover:text-primary"
    >
      {{ $t(label) }}
    </p>
  </component>
</template>
